import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDzxZi9wPlsmu35a7zWZqz5xyZwa6WayQ4",
  authDomain: "pilates-app-project.firebaseapp.com",
  databaseURL: "https://pilates-app-project-default-rtdb.firebaseio.com",
  projectId: "pilates-app-project",
  storageBucket: "pilates-app-project.firebasestorage.app",
  messagingSenderId: "885375361304",
  appId: "1:885375361304:web:438419c1acdfc9952abe6d"
};

// ✅ different name
const app2 = !getApps().some(a => a.name === "app2")
  ? initializeApp(firebaseConfig, "app2")
  : getApp("app2");

const messaging = getMessaging(app2);
export { app2, messaging };